import DeleteAccessPopover from './delete_access_popover.js';
import CreateNewAccessModal from './create_new_access_modal.js';
import EditAccessModal from './edit_access_modal.js';

export default Vue.extend({
  components: {
    'delete-access-popover': DeleteAccessPopover,
  },

  template: `
    <div class="access-container">
      <div class="access-wrapper">
        <div class="navigator divided">
          <button @click="openCreateNewAccess">新增角色</button>
        </div>
        <div class="table-responsive access-table">
          <table class="table table-noborder table-striped">
            <thead>
              <tr>
                <th>角色名称</th>
                <th>角色权限</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row" v-for="access in accesses">
                <td><div class="row-cell text-ellipsis">{{ access.name }}</div></td>
                <td class="row-cell">
                  <span class="chip text-ellipsis mr-2" v-for="action in access.actions">{{ _getActionName(action) }}</span>
                </td>
                <td class="row-cell operation-cell-box">
                  <span class="operation-cell btn-text primary-text mr-4" @click="openEditAccessModal(access)">编辑</span>
                  <delete-access-popover :access="access" @deleteMemberSuccessed="deleteMemberSuccessedFunc"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `,

  props: {
    result: {
      type: Array,
    },
    actions: {
      type: Array,
    },
  },

  data() {
    return {
      accesses: this.result,
    };
  },

  computed: {
    options() {
      return _.chain(this.actions)
        .map((access) => _.flatten(_.pairs(access)))
        .map((item) => ({ id: Number(item[0]), name: item[1] }))
        .value();
    },
  },

  methods: {
    deleteMemberSuccessedFunc(access) {
      this.accesses = _.without(this.accesses, access);
    },

    openCreateNewAccess() {
      new CreateNewAccessModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('create_new_access_modal_container'),
        propsData: {
          options: this._parseOptions([]),
          createSuccessedCallback: (access) => {
            this.accesses.push(access);
          },
        },
      });
    },

    openEditAccessModal(access) {
      new EditAccessModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit_access_modal_container'),
        propsData: {
          options: this._parseOptions(access.actions),
          access,
          editSuccessedCallback: (editedAccess) => {
            _.chain(this.accesses)
              .find((item) => item.id === editedAccess.id)
              .extend(editedAccess);
          },
        },
      });
    },

    _parseOptions(actions) {
      return _.map(this.options, (option) => {
        if (_.contains(actions, option.id)) {
          option._selected = true;
        } else {
          option._selected = false;
        }
        return option;
      });
    },

    _getActionName(action) {
      let actionName = '';
      _.each(this.actions, (item) => {
        if (item[action]) actionName = item[action];
      });
      return actionName;
    },
  },
});
